
import { Paper, Button, TableContainer, Table, TableHead, TableRow, TableCell, TablePagination, TableBody } from "@material-ui/core"
import { makeStyles } from '@material-ui/core/styles'
import { FormatoFechaIso } from "./../../../utils/FormatFecha"
import { useSelector, useDispatch } from "react-redux"
import EstatusAereos from "../Estatus"
import { useHistory } from "react-router-dom"
import { obtenerliquidacionesAuthRegistrosAction, obtenerliquidacionesAuthPaginaAction, obtenerVoucherDowloadGrupoAuthAction } from "./../../../ducks/liquidacionesAuthDuck"
import TVocuher from "./TVoucher"
import { onLoadAnction, offLoadAction } from "../../../ducks/loadDuck"
const columns = [
    { id: "numero", minWidth: 50, align: "center", label: "#" },
    { id: "paquete", minWidth: 50, align: "center", label: "Paquete" },
    { id: "cv", minWidth: 50, align: "center", label: "Clave Viaje" },
    { id: "fechaViaje", minWidth: 50, align: "center", label: "Fecha Viaje" },
    { id: "estatus", minWidth: 50, align: "center", label: "Estatus" },
    { id: "noViajes", minWidth: 50, align: "center", label: "No. Viajes" },
    { id: "accion", minWidth: 50, align: "center", label: "Grupos" },
    { id: "voucher", minWidth: 50, align: "center", label: "Voucher" },
]

const useStyles = makeStyles({
    containerRoot: {
        marginTop: "25px",
        marginBottom: "25px"
    },
    containerRootButton: {
        marginTop: "25px",
        marginBottom: "25px",
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center"
    },
    root: {
        width: '100%',
        padding: '0'
    },
    container: {
        maxHeight: 440,
    },
})

const TLiquidacionesAutorizadas = () => {
    const { liquidaciones, total, pagina, registroPagina } = useSelector(store => store.liquidacionesAuth)
    const rows = liquidaciones
    const classes = useStyles()
    const dispatch = useDispatch()
    const history = useHistory()
    const handleChangePage = (event, newPage) => {
        dispatch(onLoadAnction({message: ""}))
        dispatch(obtenerliquidacionesAuthPaginaAction({ Pagina: newPage })).then(Response => {
            dispatch(offLoadAction())
        })
    }
    const handleChangeRowsPerPage = (event) => {
        dispatch(onLoadAnction({message: ""}))
        dispatch(obtenerliquidacionesAuthRegistrosAction({ Registros: +event.target.value })).then(Response => {
            dispatch(offLoadAction())
        })
    }
    const handleDetalle = (grupo) => {
        history.push(`/Liquidaciones/Autorizados/${grupo?.compra?.pagoGrupal?.idPagoGrupal}`, {
            reservas: true
        })
    }
    return (
        <div className={classes.containerRoot}>
            <Paper className={classes.root}>
                <TableContainer className={classes.container}>
                    <Table stickyHeader aria-label="sticky table">
                        <TableHead>
                            <TableRow>
                                {columns.map((column) => (
                                    <TableCell
                                        key={column.id}
                                        align={column.align}
                                        style={{ minWidth: column.minWidth }}
                                    >
                                        {column.label}
                                    </TableCell>
                                ))}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {rows.map((row, index) => {
                                return (
                                    <TableRow hover role="checkbox" tabIndex={-1} key={row?.ClaveViaje}>
                                        <TableCell align='center'>
                                            {index + 1}
                                        </TableCell>
                                        <TableCell align='center'>
                                            {row?.Paquete}
                                        </TableCell>
                                        <TableCell align="center">
                                            {row?.ClaveViaje}
                                        </TableCell>
                                        <TableCell align="center">
                                            {`${FormatoFechaIso({ date: row?.FechaViaje })}`}
                                        </TableCell>
                                        <TableCell align="center">
                                            <EstatusAereos estatus={row?.compra?.estatusCompra?.idEstatusCompra} />
                                        </TableCell>
                                        <TableCell align="center">
                                            {`${row?.PlazaTotal}`}
                                        </TableCell>
                                        <TableCell align="center">
                                            <Button

                                                variant="outlined"
                                                color="primary"
                                                onClick={() => { handleDetalle(row) }}
                                            >
                                                Ver
                                            </Button>
                                        </TableCell>
                                        <TableCell align="center">
                                            <TVocuher Compra={row?.compra} />
                                        </TableCell>
                                    </TableRow>
                                )
                            })}
                        </TableBody>
                    </Table>
                </TableContainer>
                <TablePagination
                    rowsPerPageOptions={[10, 25, 100]}
                    component="div"
                    count={total}
                    rowsPerPage={registroPagina}
                    page={pagina}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
            </Paper>
        </div>
    )
}
export default TLiquidacionesAutorizadas